import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CarData } from './CarData';

const featuredCars = CarData.slice(0, 5);

function CarouselComponent() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const touchStart = useRef(null);

  const move = useCallback((direction) => {
    setCurrentIndex((index) => (index + direction + featuredCars.length) % featuredCars.length);
  }, []);

  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setInterval(() => move(1), 5000);
    return () => window.clearInterval(timer);
  }, [move, paused]);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowLeft') move(-1);
    if (event.key === 'ArrowRight') move(1);
  };

  const handleTouchEnd = (event) => {
    if (touchStart.current === null) return;
    const distance = touchStart.current - event.changedTouches[0].clientX;
    if (Math.abs(distance) > 45) move(distance > 0 ? 1 : -1);
    touchStart.current = null;
  };

  return (
    <section className="showcase-section">
      <div className="content-shell">
        <div className="section-heading">
          <div><p className="eyebrow">Öne çıkanlar</p><h2 className="section-title">Sürüşe ilham verenler</h2></div>
          <p className="section-copy">Koleksiyonumuzun öne çıkan modellerine göz atın. Kaydırın ya da ok tuşlarıyla ilerleyin.</p>
        </div>
        <div className="carousel-wrapper" role="region" aria-label="Öne çıkan araçlar" tabIndex="0"
          onKeyDown={handleKeyDown} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
          <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            onTouchStart={(event) => { touchStart.current = event.touches[0].clientX; setPaused(true); }}
            onTouchEnd={(event) => { handleTouchEnd(event); setPaused(false); }}>
            {featuredCars.map((car) => (
              <article className="carousel-slide" key={car.id} aria-hidden={featuredCars[currentIndex].id !== car.id}>
                <img src={car.img} alt={car.name} className="carousel-image" />
                <div className="carousel-info">
                  <span className="carousel-label">{car.year} · {car.body}</span>
                  <h3>{car.name}</h3>
                  <p className="carousel-price">€{Number(car.price).toLocaleString('tr-TR')}</p>
                </div>
              </article>
            ))}
          </div>
          <button className="carousel-control prev" onClick={() => move(-1)} aria-label="Önceki araç">‹</button>
          <button className="carousel-control next" onClick={() => move(1)} aria-label="Sonraki araç">›</button>
          <div className="carousel-dots">
            {featuredCars.map((car, index) => (
              <button key={car.id} className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)} aria-label={`${index + 1}. araca git`} aria-current={index === currentIndex} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CarouselComponent;
